import { supabase } from '../supabaseClient';

export type AccountLifecycleStatus =
  | 'active'
  | 'deactivated'
  | 'deletion_requested';

export interface AccountLifecycleState {
  account_status: AccountLifecycleStatus;
  canonical_role: string | null;
  account_deactivated_at: string | null;
  account_reactivated_at: string | null;
  account_deletion_requested_at: string | null;
  pending_export_request: boolean;
  pending_deletion_request: boolean;
  can_self_deactivate: boolean;
}

function firstRow<T>(
  value: T | T[] | null,
): T | null {
  if (Array.isArray(value)) {
    return value[0] ?? null;
  }

  return value ?? null;
}

export async function loadAccountLifecycleState():
Promise<AccountLifecycleState | null> {
  const {
    data,
    error,
  } = await supabase
    .rpc('forfeo_account_lifecycle_state')
    .maybeSingle();

  if (error) {
    throw error;
  }

  return firstRow(
    data as AccountLifecycleState | AccountLifecycleState[] | null,
  );
}

export async function deactivateMyAccount():
Promise<void> {
  const {
    error,
  } = await supabase.rpc(
    'forfeo_deactivate_my_account',
  );

  if (error) {
    throw error;
  }
}

export async function reactivateMyAccount():
Promise<void> {
  const {
    error,
  } = await supabase.rpc(
    'forfeo_reactivate_my_account',
  );

  if (error) {
    throw error;
  }
}

export async function requestMyDataExport():
Promise<string> {
  const {
    data,
    error,
  } = await supabase.rpc(
    'forfeo_request_my_data_export',
  );

  if (error) {
    throw error;
  }

  return String(data ?? '');
}

export async function requestMyAccountDeletion():
Promise<string> {
  const {
    data,
    error,
  } = await supabase.rpc(
    'forfeo_request_account_deletion',
  );

  if (error) {
    throw error;
  }

  return String(data ?? '');
}

export async function signOutAfterLifecycleChange():
Promise<void> {
  const {
    error,
  } = await supabase.auth.signOut();

  if (error) {
    throw error;
  }
}
